import React from "react";
import { NavLink } from "react-router-dom";
import { Home, MessageCircleHeart, BookHeart, Sprout, User } from "lucide-react";

const items = [
  { to: "/", label: "Home", icon: Home, testid: "nav-home" },
  { to: "/coach", label: "Coach", icon: MessageCircleHeart, testid: "nav-coach" },
  { to: "/journal", label: "Journal", icon: BookHeart, testid: "nav-journal" },
  { to: "/growth", label: "Growth", icon: Sprout, testid: "nav-growth" },
  { to: "/profile", label: "Profile", icon: User, testid: "nav-profile" },
];

export default function BottomNav() {
  return (
    <nav
      data-testid="bottom-navigation"
      className="fixed bottom-0 inset-x-0 z-40 backdrop-blur-xl bg-[#F9FAF7]/95 border-t border-[#B7CCB1]"
    >
      <div className="max-w-2xl mx-auto grid grid-cols-5 px-2">
        {items.map(({ to, label, icon: Icon, testid }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            data-testid={testid}
            className={({ isActive }) =>
              `relative flex flex-col items-center justify-center gap-1 py-3 transition-colors ${
                isActive
                  ? "text-[#2E4531]"
                  : "text-[#2E3A2E] hover:text-[#2E4531]"
              }`
            }
          >
            {({ isActive }) => (
              <>
                {isActive && (
                  <span
                    aria-hidden
                    className="absolute top-0 h-[3px] w-10 rounded-full bg-[#4F6F52]"
                  />
                )}
                <Icon size={23} strokeWidth={isActive ? 2.6 : 2.2} />
                <span
                  className={`text-[12px] tracking-[0.01em] ${
                    isActive ? "font-bold" : "font-semibold"
                  }`}
                >
                  {label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
